import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardBody from 'components/Card/CardBody.js';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import BubbleContainer from 'components/BubbleContainer/BubbleContainer';
import styles from 'assets/jss/material-kit-react/views/profilePage.js';

const useStyles = makeStyles<Theme>((theme) => ({
  mainContainer: {
    position: 'relative',
    zIndex: 2,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
  },
  container: {
    ...styles.container,
    position: 'relative',
    zIndex: 3,
  },
  contentContainer: {
    textAlign: 'center',
    padding: '40px 20px',
  },
  headLineStyle: {
    fontSize: '48px',
    fontWeight: '500',
    marginBottom: '20px',
    color: theme.palette.text.primary,
  },
  subHeadLineStyle: {
    fontSize: '24px',
    fontWeight: '400',
    marginBottom: '30px',
    color: theme.palette.text.secondary,
  },
  errorCode: {
    fontSize: '120px',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    marginBottom: '20px',
    lineHeight: '1',
  },
  centeredHeader: {
    textAlign: 'center',
    margin: 0,
  },
}));

export default function NotFoundPage() {
  const classes = useStyles();
  const { t } = useTranslation();
  useDocumentTitle('404 - Not Found');

  return (
    <div className={classes.mainContainer}>
      <div className={classes.container}>
        <Card>
          <CardHeader color="primary">
            <h4 className={classes.centeredHeader}>404 - Page Not Found</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12}>
                <div className={classes.contentContainer}>
                  <div className={classes.errorCode}>404</div>
                  <h1 className={classes.headLineStyle}>{t('notFoundPage.notFoundHeadline')}</h1>
                  <h2 className={classes.subHeadLineStyle}>
                    {t('notFoundPage.notFoundSubHeadline')}
                  </h2>
                  <Link to={'/'} style={{ textDecoration: 'none' }}>
                    <Button color="primary" size="lg">
                      {t('notFoundPage.goBack')}
                    </Button>
                  </Link>
                </div>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </div>
      <BubbleContainer pageKey="notfound" helpText={t('help.notFound')} />
    </div>
  );
}
